"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _constants = require("../constants");

var _default = {
  dev: [{
    product: 'dev-switch-test',
    skillId: '1831176330',
    skillName: 'Bot_Switch'
  }, {
    product: _constants.PRODUCT_DEFAULT,
    skillId: '327455714',
    skillName: 'Bot_Dev'
  }],
  test: [{
    product: _constants.PRODUCT_DEFAULT,
    skillId: '327455714',
    skillName: 'Bot_Dev'
  }],
  prod: [{
    product: 'godaddy-email-marketing-1000013',
    skillId: '1838564830',
    skillName: 'GD-sidekick-GEM-en-us'
  }, {
    product: _constants.PRODUCT_DEFAULT,
    skillId: '1778529730',
    skillName: 'GD-Sidekick-en-US'
  }]
};
exports["default"] = _default;